<template>
  <v-container fluid align-start ma-0 pa-2 class="container-height">
    <v-row no-gutters fill-height>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle"           
          >
          
          <template v-slot:body>
            <!-- <v-layout column overflow-auto> -->
              <v-row>
							<v-col cols="12" class="pa-0">
								<i-card-top
									class="d-md-flex"
									outlined

                  :useBtnList="[
                      'btnRetrieve', //Retrieve
                      'btnSave',    //Save
                      'btnSaveExcel'   //Save Excel
                    ]"
                    @btnRetrieve="btnRetrieve()"                    
                    @btnSaveExcel="btnSaveExcel()"
                    @btnSave="btnSave()"                     
								>
                <template v-slot:body>
                      <v-layout column>
                        <v-row no-gutters class="center pa-2 pb-0">
                          <v-icon small color="blue">mdi-circle</v-icon>
                          <span class="pa-1 subTitle">Ship No : </span>
                          <v-col cols="2">
                            <v-select
                                v-model="selectShipNo"                            
                                :items="shipNoList"
                                item-value="shipNo"
                                item-text="shipNo"
                                return-object
                                single-line
                                outlined
                                dense
                                @change="changeShipNo"
                                 />                            
                          </v-col>
                          <v-icon small color="blue" class="pl-2">mdi-circle</v-icon>
                          <span class="pa-1 subTitle"> Por No: </span>
                          <v-col cols="2">
                            <v-select
                                v-model="selectPorNo"
                                :items="porList"
                                item-value="porNo"
                                item-text="porNo"
                                return-object
                                single-line
                                outlined
                                dense                                
                                />                                                      
                          </v-col>
                          <v-icon small color="blue" class="pl-2">mdi-circle</v-icon>
                          <span class="pa-1 subTitle"> Block: </span>
                          <v-col cols="2">
                            <v-select
                               v-model="selectBlock"
                                :items="blockList"
                                item-value="block"
                                item-text="block"
                                return-object
                                single-line
                                outlined
                                dense />                                                      
                          </v-col>
                        </v-row>
                      </v-layout>
                    </template>
								</i-card-top>
							</v-col>
						</v-row>              
        
            <v-row no-gutters>
                <v-col cols="14" class="pt-1">                  

                  <DxDataGrid id="epms9109"                   
                    class="hipGridHeight"
                    :ref="epms9109Ref"
                    :data-source="gridMainList" 
                    :remote-operations="false" 
                    :hover-state-enabled="true"
                    :allow-column-resizing="true" 
                    :allow-column-reordering="true"
                    :row-alternation-enabled="true" 
                    :show-borders="true" 
                    :width="grid.width"
                    :show-row-lines="true" 
                    key-expr="id" 
                    :focused-row-enabled="false"
                    :column-hiding-enabled="false" 
                    :selection="{ mode: 'none' }"
                    :sorting="{ mode: 'none' }" 
                    @editing-start="onEditingStart"                                       
                    @cellPrepared="cellPrepared"   
                    @editor-preparing ="editorPrepare"               
                    >                    

                    <DxEditing :use-icons="true" mode="cell" />
                    <DxColumn data-field="rnum" caption="No" width="5%" data-type="string" alignment="center" :allow-editing="false" />                                      
                    <DxColumn caption= "Ship No" width="10%" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="porno" caption="POR No" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="porseq" caption="Seq" width="5%" data-type="string" alignment="center" :allow-editing="false" />    
                    </DxColumn>                  
                    <DxColumn data-field="block" caption="Block" width="5%" data-type="string" alignment="center" :allow-editing="false" />

                    <DxColumn caption= "Activity" width="10%" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="mact" caption="Part No" width="10%" data-type="string"  alignment="center" :allow-editing="false" />
                    </DxColumn>
                    
                    <DxColumn caption= "Specification" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="stoqty" caption="Qty" width="10%" data-type="number" format="#,###" :allow-editing="false" />
                      <DxColumn data-field="partunitwgt" caption="Unit Weight" width="10%" data-type="number" format="#,###.##" :allow-editing="false" />    
                    </DxColumn>  
                    <DxColumn data-field="psd" caption="Material Need Date" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn caption= "Delivery No" width="10%" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="delyno" caption="Delivery Date" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    </DxColumn>
                    <DxColumn caption= "Request Date" width="10%" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="delyloc" caption="Request Location" width="10%" data-type="string" alignment="center"  :allow-editing="false" />
                    </DxColumn>
                    <DxColumn caption= "Keeping Location" width="10%" data-type="string" alignment="center" :allow-editing="true" >
                      <DxColumn data-field="lotloc" caption="Keeping Lot" width="10%"  data-type="string" alignment="center" MaxInputLength = 5   :allow-editing="true" />
                    </DxColumn>
                    <DxColumn caption= "Keeping Date" width="5%"  alignment="center" :allow-editing="true" >
                      <DxColumn data-field="keepdte" caption="Keeping PIC" width="5%" data-type="date" alignment="center"  :allow-editing="true" />
                    </DxColumn>

                    <DxColumn caption= "Keeping Date" width="5%" data-type="string" alignment="center" :allow-editing="true" >
                      <DxColumn data-field="keeppic" caption="Keeping PIC" width="5%" data-type="string" alignment="center"  :allow-editing="true" />
                    </DxColumn>
              
                  <DxPaging :enabled="true" :page-size="20" />                  
                  <DxPager :visible="true" :showInfo="true" />
                  </DxDataGrid>
                </v-col>
              </v-row>
            <!-- </v-layout> -->
          </template> 
        </i-card-vertical>
      </v-col>
    </v-row>    
  </v-container>
</template>

<script>
import { DxDataGrid,  DxEditing, DxColumn , DxPager } from 'devextreme-vue/data-grid'
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import DxDateBox from 'devextreme-vue/date-box'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import { getDateFormat, getCurrentDate, getFirstDate , getFirstDay, getNumComma} from '@/utils/common.js'
import { getShipNoList1, epms9000_block, epms9000_por_no } from '@/api/view/hip/common/common.js'
import { epms9109List, epms9109Save, epms9109Xls } from '@/api/view/hip/90/epms9109.js'
import { reportView } from '@/api/view/hip/common/common.js'
import notify from 'devextreme/ui/notify' // message
import dayjs from 'dayjs';


export default {
  name: 'epms9109',
  mixins: [baseview, BaseDataGrid],
  components: {
    ICardVertical,
    'i-card-top': iCardTop,
    DxDataGrid,
    DxColumn,
    DxEditing,    
    DxPager
    
  },
  data() {
    return {
      menuTitle: this.$route.meta.title,
      epms9109Ref: 'epms9109Ref',
      useBtnList: ['btnRetrieve', 'btnSave', 'btnPrint'],
      gridMainList: [],      
      selectShipNo: '',
			shipNoList: [],     
      selectPorNo: '',
      porList: [],     
      selectBlock: '',      
      blockList: [],     
      makerCd: this.$store.state.user.makerCd,
    }
  },
  computed: {
    gridInstance() {
      return this.GetDataGrid(this.epms9109Ref)
    },
    
  },

  mounted() {    
      this.init()
      this.gridInstance.option('defaultPaging', false)      
  },

  methods: { 

    async getShipNoList() {
      const param = {
        makerCd: this.makerCd
      }

      await getShipNoList1(param).then(async res => {        

        this.shipNoList = res.list
        this.shipNoList.unshift({
          shipNo: ''
        })
        this.selectShipNo = this.shipNoList[0]

        await this.getBlockList()
        await this.getPorNoList()
      })
    },

    async getPorNoList() {
          this.openLoading()

          const param = {
            incNotPo: 'Y',
            shipNo: this.selectShipNo.shipNo,
            makerCd: this.makerCd
          }

          await epms9000_por_no(param).then(res => {            

            this.porList = res.list
            this.porList.unshift({
              porNo: ''
            })
            this.selectPorNo = this.porList[0]
          }).finally(() => {
            this.endLoading()
          })
    },

    async getBlockList() {
      this.openLoading()

      const param = {
        incNotPo: 'Y',
        shipNo: this.selectShipNo.shipNo,
        makerCd: this.makerCd
      }

      await epms9000_block(param).then(res => {
        
        this.blockList = res.list
        this.blockList.unshift({
          block: ''
        })
        this.selectBlock = this.blockList[0]
      }).finally(() => {
        this.endLoading()
      })
    },

        changeShipNo(e){
          this.selectBlock = null
          this.blockList = []
          this.selectPorNo = null
          this.porNoList = []

          this.getBlockList()
          this.getPorNoList()

        },
        init(){				
            this.getShipNoList()
          },

        btnRetrieve(){      
          if(this.selectShipNo === null) {
            this.vToastify(this.$t('Please select Ship No'), 'warn')
            return
          }
          if(this.selectPorNo === null){
            this.selectPorNo = ''
          }
          if(this.selectBlock === null){
            this.selectBlock = ''
          }
          this.doSearchMain()
        },

        async doSearchMain(){
          this.openLoading('searching')
          let params = {
            makerCd: this.$store.state.user.makerCd,
            shipNo: this.selectShipNo.shipNo,
            porNo: this.selectPorNo.porNo,
            block: this.selectBlock.block
          }
          
          await epms9109List(params).then(res => {       
            // this.gridMainList = res.list       

              let list = []
              let cnt = 1;
              
              res.list.forEach(e => {
                
                list.push(
                  {
                    id: cnt++ , rnum: e.rnum, porno: e.shipNo, porseq: e.shipNo,  block: e.block, mact: e.mact, stoqty: e.partspec, partunitwgt: e.partspec, 
                    psd: e.psd, delyno: e.delyno, delyloc: e.psd, lotloc: e.delyloc, keepdte: e.keepdte, bomserno: e.bomserno
                  },
                  {
                    id: cnt++ , rnum: e.rnum, porno: e.porno,  porseq: e.porseq,  block: e.block, mact: e.partno, stoqty: e.stoqty, partunitwgt: e.partunitwgt,             
                    psd: e.psd, delyno: e.delydte, delyloc: e.lotno, lotloc: e.lotloc, keepdte: e.keeppic, bomserno:  e.bomserno
                  }
                )
              });
              
              this.gridMainList = list


          }).finally(() => {
            this.endLoading()
          })

},

async btnSave() {      
      if (this.gridMainList.length > 0) {
        await this.gridInstance.saveEditData()
        
        let params = []        
        let j = 0 
          
        for (let i = 0; i < this.gridMainList.length; i++) {          

          let list =  this.gridMainList[i]  
          let list1 =  this.gridMainList[i + 1]  
                      
            if (i%2 == 0 && (list.keepdte != null || list1.lotloc != null || list1.keepdte != null) ) {

                  params.push({
                      id: i,
                      shipNo: list.porno,                              
                      porno : list1.porno,
                      porseq: list1.porseq,
                      mact  : list.mact,
                      bomserno: list.bomserno,     
                      lotloc : list1.lotloc,
                      keepdte: getDateFormat(list.keepdte),      
                      keeppic:  list1.keepdte,      
                      userId: this.$store.state.user.makerCd    
                      })
                     
                    }  

        }

        this.openLoading('updating')
        epms9109Save(params).then(res => {
          if (res.body === 'Y') {
            notify(this.$t('Request is Update completed.'), 'success', 3000)
          } else {
            this.vToastify(this.$t('An error was occured :' + res.body), 'warn')
          }
        })
            .catch(error => {
              this.vToastify(error, 'warn')
            })
            .finally(() => {              
              this.btnRetrieve()
            })
      }
    },



    btnSaveExcel(){            
      this.openLoading('Excel Saving')
      let params = {
        makerCd: this.$store.state.user.makerCd,
        shipNo: this.selectShipNo.shipNo,
        porNo: this.selectPorNo.porNo,
        block: this.selectBlock.block
      }
      epms9109Xls(params)
      this.endLoading()
    },


      cellPrepared(e) {

        if(e.rowType === 'header') {
          if (e.column.caption === 'Keeping Date' || e.column.caption === 'Keeping PIC') {
                  e.cellElement.setAttribute('colspan', 2)
              }
        }

         if(e.rowType === 'data') {
          //  console.log(e)
              if ((Number(e.rowIndex) % 2 == 0) && (e.column.caption === 'No' || e.column.caption === 'Block' ||e.column.caption === 'Material Need Date')) {
                        e.cellElement.setAttribute('rowspan', 2)
              }
                  else if ((Number(e.rowIndex) % 2 != 0) && (e.column.caption === 'No' || e.column.caption === 'Block' ||e.column.caption === 'Material Need Date')) {
                        e.cellElement.style.display = 'none'
              }    
              
              if (Number(e.rowIndex) % 2 == 0) {
                    if (e.columnIndex == 1 ||e.columnIndex == 5) {
                        e.cellElement.setAttribute('colspan', 2)
                    }
                   else if (e.columnIndex == 2 ||  e.columnIndex == 6){
                        e.cellElement.style.display = 'none'
                  }       
                }      
            
                if (e.column.dataField === 'keepdte' && e.columnIndex === 11) {
                  e.cellElement.setAttribute('colspan', 2)

                } else if (e.column.dataField === 'keeppic' && e.columnIndex === 12) {
                  e.cellElement.style.display = 'none'
                }
                
           }


      },
      
      onEditingStart(e) {    
        console.log(e)    
          if (e.column.dataField === 'keepdte') {            
              if (Number(e.key) % 2 == 0) {              
                e.column.dataType = 'string'        
              }
              else{
                e.column.dataType = 'date'        
              }
          } 
    },

    editorPrepare(e) {
            if (e.dataField === 'lotloc' && e.parentType === 'dataRow') { 
                 e.editorOptions.maxLength = 5;
            }  
        },

          
},
   

}

</script>
<style lang="scss" scoped>
  .subTitle {
    font-weight: bold;
    color: black;
  }  
  .v-btn {
    text-transform: unset !important;
    // height: 16px !important;
  }
  
.allBtn, .file-link {
  cursor: pointer;
}
.allBtn:hover, .file-link:hover {
  color: #4980BC;
}

</style>